import { createHook } from '@studio/react-utils/store';
import { depot } from './depot.js';
import type { Producer } from './types.js';

/** State slicer */
export { Slicer } from './slicer.js';

/**
 * Hook to obtain the (reactive) application data depot.
 *
 * @returns Data depot.
 */
export const useDepot = createHook(depot);

/**
 * Hook to obtain the depot producer (not reactive).
 *
 * @returns Data depot producer.
 */
export const useProducer = (): Producer => depot.getState().produce;
